import { AxiosError, AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import { ExplainResponse, ExplainSubjectKind, typicodeApi } from 'shared/api';

export type ExplainTarget = {
  kind: ExplainSubjectKind;
  subjectId: string;
  subjectName: string;
  diseaseId: string;
  diseaseName: string;
};

export const getDiseaseExplainAsync = (target: ExplainTarget | null) =>
  useQuery<AxiosResponse<ExplainResponse>, AxiosError<{ message?: string | string[] }>>(
    ['diseaseExplain', target?.kind, target?.subjectId, target?.diseaseId],
    ({ signal }) => {
      if (!target) return Promise.reject(new Error('No explain target'));
      return typicodeApi.vaccinationExplain.getExplain(target.kind, target.subjectId, target.diseaseId, signal);
    },
    {
      enabled: !!target,
      retry: false,
      refetchOnWindowFocus: false,
      cacheTime: 0,
    },
  );
